import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import DocumentPicker, {
  DocumentPickerResponse,
} from "react-native-document-picker";
import { Platform } from "react-native";
import { getStorageData } from "framework/src/Utilities";
export const baseURL = require("../../../framework/src/config.js").baseURL;

interface IUploadedFile {
  data: {
    id: string;
    type: string;
    attributes: {
      id: number;
      account_id: number;
      files:
        | {
            id: number;
            file_name: string;
            file_url: string;
          }[]
        | null;
      status: string;
    };
  };
  meta: {
    message: string;
  };
}
interface IDownloadResponse {
  jobId: number;
  statusCode: number;
  bytesWritten: number;
}

type FileCategory = 'image' | 'video' | 'audio' | 'pdf';

const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/svg+xml', 'video/mp4', 'video/x-msvideo', 'video/avi', 'audio/mpeg', 'application/pdf'];

const MAX_FILE_SIZES: Record<FileCategory, number> = {
  image: 10485760, 
  video: 104857600,
  audio: 10485760, 
  pdf: 10485760, 
};

const MAX_LIMITS: Record<FileCategory, number> = {
  image: 20,
  video: 5,
  audio: 5,
  pdf: 5,
};

// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  onFilesUploaded: any;
  portfolioImgs:any[]
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  token: string;
  filesWeb: File[];
  files: any[];
  uploadedFiles: IUploadedFile[];
  filesStatus: (undefined | "uploading" | "success" | "failed")[];
  isUploadPortfolioOpen:boolean;
  progress: number;
  remainingTime: number;
  isUploading: boolean; 
  isPaused:boolean;
  currentFile: File | null;
  uploadInterval:any;
  isUploadSuccess:boolean;
  validPortfolioError:any;
  totalFiles: any,  
  totalSize:number,
  completedFiles: number, 
  isMediaUploadSuccessModalOpen:boolean;
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class BulkUploadingController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  createBulkUploadCallId: string = "";
  getBulkUploadCallId: string = "";
  deleteBulkUploadCallId: string = "";
  userMediaUploadCallId:string = "";
  maxFileSize = 5e6;
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      token: "",
      filesWeb: [],
      files: [],
      uploadedFiles: [],
      filesStatus: [],
      isUploadPortfolioOpen:false,
      progress: 0, 
      remainingTime: 30, 
      isUploading: false, 
      isPaused:false,
      uploadInterval: null,
      isUploadSuccess:false,
      currentFile: null,
      validPortfolioError:'',
      totalFiles: [],  
        completedFiles: 0, 
        totalSize:0,
      isMediaUploadSuccessModalOpen:false,
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    runEngine.debugLog("Message Recived", message);

    if (getName(MessageEnum.SessionResponseMessage) === message.id) {
      runEngine.debugLog("Message Recived", message);

      const token = message.getData(getName(MessageEnum.SessionResponseToken));
      if (token) {
        this.setState({ token: token });
      }
    } else if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const errorReponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (errorReponse) {
        this.showAlert("Alert", configJSON.somethingWentWrongMsg);
      }
      if (apiRequestCallId) {
        if (apiRequestCallId === this.createBulkUploadCallId) {
          let filesStatus = this.state.filesStatus;
          if (responseJson && responseJson.data) {
            filesStatus[filesStatus.length - 1] = "success";
          } else {
            filesStatus[filesStatus.length - 1] = "failed";
          }
          this.setState({ filesStatus });
          this.uploadFile();
        } else if (
          apiRequestCallId === this.getBulkUploadCallId &&
          responseJson !== undefined
        ) {
          !responseJson.errors &&
            this.setState({ uploadedFiles: responseJson });
        } else if (
          apiRequestCallId === this.deleteBulkUploadCallId &&
          responseJson !== undefined
        ) {
          this.showAlert("Alert", configJSON.deletedSuccessMsg);
          this.getUploadedFiles();
        } else if (apiRequestCallId === this.userMediaUploadCallId){
          this.handleMediaResponse(responseJson);
        }
      }
    }

    // Customizable Area End
  }

  // Customizable Area Start
  componentDidMount = async () => {
    this.getToken();
  };

  getToken = () => {
    const tokenMsg: Message = new Message(
      getName(MessageEnum.SessionRequestMessage)
    );
    this.send(tokenMsg);
  };

  uploadFile = () => {
    const length = this.isPlatformWeb()
      ? this.state.filesWeb.length
      : this.state.files.length;

    if (length > this.state.filesStatus.length) {
      this.uploadFileSingle(this.state.filesStatus.length);
      this.setState({ filesStatus: [...this.state.filesStatus, "uploading"] });
    }
  };

  uploadFileSingle = (index: number) => {
    const header = {
      token: this.state.token,
    };

    const formData = new FormData();
    formData.append(
      "files[]",
      this.isPlatformWeb()
        ? this.state.filesWeb[index]
        : this.state.files[index]
    );

    const createBulkUploadMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.createBulkUploadCallId = createBulkUploadMsg.messageId;

    createBulkUploadMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.createBulkUploadEndpoint
    );

    createBulkUploadMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    createBulkUploadMsg.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      formData
    );

    createBulkUploadMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.createBulkUploadMethod
    );

    runEngine.sendMessage(createBulkUploadMsg.id, createBulkUploadMsg);
  };

  removeFileWeb = (index: number) => {
    this.setState({
      filesWeb: Array.from(this.state.filesWeb).filter(
        (file, fileIndex) => fileIndex !== index
      ),
    });
  };

  removeFile = (index: number) => {
    this.setState({
      files: Array.from(this.state.files).filter(
        (file, fileIndex) => fileIndex !== index
      ),
    });
  };

  clearAllFile = () => {
    this.setState({ filesWeb: [], files: [], filesStatus: [] });
  };

  onChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    let tempFile: File[] = [];
    if (event.target.files) {
      for (let iterator = 0; iterator < event.target.files.length; iterator++) {
        if (event.target.files[iterator].size > this.maxFileSize) {
          this.showAlert(
            "Alert",
            event.target.files[iterator].name + configJSON.fileSizeErrorMsg
          );
        } else {
          tempFile.push(event.target.files[iterator]);
        }
      }
    }
    tempFile.length > 0 &&
      this.setState({
        filesWeb: [...this.state.filesWeb, ...tempFile],
      });
  };

  selectFiles = async () => {
    try {
      const pickerResult = await DocumentPicker.pickMultiple({
        presentationStyle: "fullScreen",
        copyTo: "cachesDirectory",
      });
      const tempFile: DocumentPickerResponse[] = pickerResult.filter((result) => {
        if (result.size && result.size > this.maxFileSize) {
          this.showAlert("Alert", result.name + configJSON.fileSizeErrorMsg);
          return false;
        } else {
          return true;
        }
      });

      this.setState({
        files: [...this.state.files, ...tempFile],
      });
    } catch (error) {
      this.showAlert("Alert", configJSON.downloadingFailedMsg);
    }
  };

  getUploadedFiles = () => {
    const header = {
      "Content-Type": configJSON.apiContentType,
      token: this.state.token,
    };

    const getBulkUploadMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getBulkUploadCallId = getBulkUploadMsg.messageId;

    getBulkUploadMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getBulkUploadEndpoint
    );

    getBulkUploadMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    getBulkUploadMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getBulkUploadMethod
    );

    runEngine.sendMessage(getBulkUploadMsg.id, getBulkUploadMsg);
  };

  deleteFile = (fileGroupId: string) => {
    const header = {
      "Content-Type": configJSON.apiContentType,
      token: this.state.token,
    };

    const deleteBulkUploadMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.deleteBulkUploadCallId = deleteBulkUploadMsg.messageId;

    deleteBulkUploadMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.deleteBulkUploadEndpoint}/${fileGroupId}`
    );

    deleteBulkUploadMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    deleteBulkUploadMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.deleteBulkUploadMethod
    );

    runEngine.sendMessage(deleteBulkUploadMsg.id, deleteBulkUploadMsg);
  };

  fileDownloadHandler = (filePath: string, fileName: string) => {
    if (Platform.OS !== "web") {
      try {
        const RNFS = require("react-native-fs");
        const dirPath = this.isPlatformiOS()
          ? RNFS.DocumentDirectoryPath
          : RNFS.DownloadDirectoryPath;
        const toFile = `${dirPath}/${Date.now()}${fileName}`;
        RNFS.downloadFile({
          fromUrl: baseURL + filePath,
          toFile,
        }).promise.then((response: IDownloadResponse) => {
          if (response.statusCode === 200) {
            this.showAlert("Alert", configJSON.downloadedSuccessMsg + toFile);
          } else {
            this.showAlert("Alert", configJSON.downloadingFailedMsg);
          }
        });
      } catch (error) {
        this.showAlert("Alert", configJSON.downloadingFailedMsg);
      }
    }
  };

  handleNewPortfolioModalOpen = () => {
    this.setState({ isUploadPortfolioOpen: true });
  };

  handlePortfolioClose = () => {
    this.setState({  isUploadPortfolioOpen: false ,validPortfolioError :'' });
  }

  handlebrowseFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.validateFiles(files);
    }
  };

  handleFileDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
      this.validateFiles(files);
    }
  };

  startUpload = (files: File[]) => {
    if (!files.length) return;

    const totalSize = files.reduce((acc, file) => acc + file.size, 0) / (1024 * 1024);
    const baseTime = files.length * 2;
    const sizeFactor = totalSize / 5;
    const estimatedTime = Math.ceil(Math.max(baseTime, sizeFactor));

    this.setState(
      {
        isPaused: false,
        progress: 0,
        remainingTime: estimatedTime,
        totalFiles: files.length,
        completedFiles: 0,
        totalSize,
      },
      () => {
        this.uploadAllFiles(files); 
        this.setState({ isUploading: true });
        this.startUploadInterval(estimatedTime);
      }
    );
  };

  progressCheck = (progress: number) => {
    return Number(progress) > 100 ? 100 : progress
  }

  startUploadInterval = (estimatedTime: number) => {
    const interval = estimatedTime / 10;
    const uploadInterval = setInterval(() => {
      if (this.state.progress >= 100) {
        clearInterval(uploadInterval);
      } else {
        this.setState((prevState) => ({
          progress: prevState.progress + 10,
          remainingTime: prevState.remainingTime - interval,
        }));
      }
    }, interval * 1000);

    this.setState({ uploadInterval });
  };

  uploadAllFiles = async (files: File[]) => {
    for (const file of files) {
      try {
        const uploadedFileUrl = await this.userMediaUpload(file);
        this.handleSucessUpload(file, uploadedFileUrl);
      } catch (error) {
        if (this.state.uploadInterval) {
          clearInterval(this.state.uploadInterval);
        }
        this.setState((prevState) => ({
          validPortfolioError: [...prevState.validPortfolioError, `${file.name}: ${error}`],
          isUploading: false,
          isPaused: false,
          progress: 0,
          remainingTime: 100,
          uploadInterval: null,
          currentFile: null,
        }));
        break;
      }
    }
  };   

  handleSucessUpload = (file: File, urlFromApi: string) => {
    if (!file) return;
    const determineFileType = (type: string) => {
      if (type.startsWith("image")) return "image";
      if (type.startsWith("video")) return "video";
      if (type.startsWith("audio")) return "audio";
      return "pdf";
    };
    const newFile = {
      id: Date.now(),
      url: urlFromApi,
      type: determineFileType(file.type),
    };
    const updatedPortfolioImgs = [...(this.props.portfolioImgs || []), newFile];
    this.setState(
      (prevState) => ({
        completedFiles: prevState.completedFiles + 1,
        progress: Math.min(100, ((prevState.completedFiles + 1) / prevState.totalFiles) * 100),
      }),
      () => {
        if (this.state.completedFiles === this.state.totalFiles) {
          this.setState({
            isMediaUploadSuccessModalOpen: true,
            isUploading: false,
            isUploadPortfolioOpen: false,
          });
        }
      }
    );
    this.props.onFilesUploaded(updatedPortfolioImgs);
  };

  pauseUpload = () => {
    if (this.state.uploadInterval) {
      clearInterval(this.state.uploadInterval);
      this.setState({ isPaused: true, uploadInterval: null });
    }
  };

  resumeUpload = () => {
    if (this.state.isPaused && this.state.currentFile) {
      const estimatedTime = this.state.remainingTime;
      this.setState({ isPaused: false }, () => {
        this.startUploadInterval(estimatedTime);
      });
    }
  };


  cancelUpload = () => {
    if (this.state.uploadInterval) {
      clearInterval(this.state.uploadInterval);
    }
    this.setState({
      isUploading: false,
      isPaused: false,
      progress: 0,
      remainingTime: 100,
      uploadInterval: null,
      currentFile: null,
    });
  };

  validateFiles = (files: FileList) => {
    const validFiles: File[] = [];
    const errors: string[] = [];

    const FILE_CATEGORIES: Record<string, FileCategory> = {
      image: 'image',
      video: 'video',
      audio: 'audio',
      pdf: 'pdf',
    };

    const determineFileType = (type: string): FileCategory => FILE_CATEGORIES[type.split('/')[0]] || 'pdf';

    const fileCounts: Record<FileCategory, number> = {
      image: 0,
      video: 0,
      audio: 0,
      pdf: 0,
    };
    const existingFiles = this.props.portfolioImgs || [];
    existingFiles.forEach(({ type }: { type: string }) => {
      const fileType = determineFileType(type);
      fileCounts[fileType]++;
    });
    const validateFile = (file: File): string | null => {
      const type = determineFileType(file.type);
      const validations = [
        { condition: !ALLOWED_TYPES.includes(file.type), message: `${file.name} has an invalid file type.` },
        { condition: file.size > MAX_FILE_SIZES[type], message: `${file.name} exceeds the ${MAX_FILE_SIZES[type] / (1024 * 1024)} MB limit.` },
        { condition: fileCounts[type] >= MAX_LIMITS[type], message: `You can upload a maximum of ${MAX_LIMITS[type]} ${type}s.` }
      ];

      return validations.find(({ condition }) => condition)?.message || null;
    };

    Array.from(files).forEach((file) => {
      const error = validateFile(file);
      if (error) {
        errors.push(error);
      } else {
        const fileType = determineFileType(file.type);
        fileCounts[fileType]++;
        validFiles.push(file);
      }
    });

    this.setState({
      validPortfolioError: errors.length ? errors : [], 
      isUploading: !errors.length,
      isPaused: false,
      progress: 0,
      remainingTime: 100,
    }, () => {
      if (!errors.length) this.startUpload(validFiles);
    });
  };

  handleDragOver = (event: { preventDefault: () => void; }) => {
    event.preventDefault();
  };

  pendingMediaUploadResolve?: (url: string) => void;
  pendingMediaUploadReject?: (error: string) => void;

  userMediaUpload = async (file: File): Promise<string> => {
    const token = await getStorageData(configJSON.TOKEN);
    const formData = new FormData();
    formData.append("upload_media[]", file);
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.userMediaUploadCallId = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.postBulkUploadingEndPoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify({ token }));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), formData);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.createBulkUploadMethod);
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return new Promise((resolve, reject) => {
      this.pendingMediaUploadResolve = resolve;
      this.pendingMediaUploadReject = reject;
    });
  };
  
  handleMediaResponse = (response: any) => {
    if (response) {
      const uploadedUrl = response?.data?.attributes?.upload_media;
      this.pendingMediaUploadResolve?.(uploadedUrl);
    }
    this.setState({ validPortfolioError:''})
    this.pendingMediaUploadResolve = undefined;
    this.pendingMediaUploadReject = undefined;
  };
  // Customizable Area End
}
